<div class="row">
    <div class="search-bar col-8">
        <img src="assets/icons/search.svg" alt="Search icon" class="search-icon" />
        <input [(ngModel)]="searchTemp" type="text" class="search-input" [placeholder]="'COMMON.SEARCH' | translate"
            [disabled]="selectedEmcOption == null" (keyup.enter)="search()" />
    </div>
    <div class="col-4">
        <div class="dropdown">
            <button
                [disabled]="!emcOptions || emcOptions.length === 0"
                (click)="toggleDropdown()" 
                class="dropdown-button"
            >
                <span class="search-name">
                    {{ searchName | translate}}
        </span>
                <img src="../../../assets/icons/ng_v3/dropdown-icon.svg" alt="dropdown icon" />
            </button>
            <div *ngIf="dropdownOpened" class="dropdown-options-search">
                <div *ngFor="let o of emcOptions; let i = index" (click)="selectSearchOption(o)"
                    class="dropdown-option-search">
                    <span>{{o.labelName}}</span>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- 
<select name="emc-select" (change)="selectEmcType($event)" class="dropdown-button">
            <option value="" [selected]="!selectedEmcOption" disabled>{{'COMMON.SEARCH_BY' | translate}}</option>
            <option [selected]="selectedEmcOption == o" *ngFor="let o of emcOptions; let i = index" [value]="o.id">
                {{ o.labelName }}
            </option>
        </select> -->